module.exports = __webpack_public_path__ + "img/undressed-woman-1.559cc0b4.jpg";